import { memo } from 'react';
import { Element, RouterLink } from 'src/components';
import { ITopic } from 'src/interface';
import styles from './styles.module.scss';

interface IProps {
    header: ITopic;
}

export function ContentHeader(props: IProps) {
    const { header } = props;
    return (
        <Element renderAs="h4" className={styles['bm-topic-header']}>
            <RouterLink
                to={header.url || '/'}
            >
                {header.title}
            </RouterLink>
        </Element>
    );
}

export default memo(ContentHeader);
